// extracted by mini-css-extract-plugin
export default {"section":"Mid_section__TotX6","purpose":"Mid_purpose__uOudy"};